module.exports = __webpack_public_path__ + "assets/img/3.e813fd8d.png";